import React, { useState } from "react";
import { AuthUser } from "../types/auth";
import { localLogin, azureLogin } from "../services/authService";
import "./LoginPage.css";

interface LoginPageProps {
  onLogin: (user: AuthUser) => void;
  errorParam?: string | null;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin, errorParam }) => {
  const [showLocal, setShowLocal] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(
    errorParam === "azure_auth_failed"
      ? "Azure sign-in failed. Please try again."
      : errorParam === "azure_no_code"
      ? "Azure sign-in was cancelled."
      : null
  );
  const [loading, setLoading] = useState(false);

  const handleLocalLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const user = await localLogin(username, password);
      onLogin(user);
    } catch (err: any) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span className="login-logo-icon">📅</span>
        </div>
        <h1 className="login-title">Company Schedule</h1>
        <p className="login-subtitle">Sign in to continue</p>

        {error && <div className="login-error">{error}</div>}

        <button type="button" className="login-btn-azure" onClick={azureLogin}>
          <svg className="login-ms-icon" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Sign in with Microsoft
        </button>

        <div className="login-divider">
          <button
            className="login-local-toggle"
            onClick={() => setShowLocal((v) => !v)}
          >
            {showLocal ? "▲ Hide" : "▼ Local admin login"}
          </button>
        </div>

        {showLocal && (
          <form className="login-local-form" onSubmit={handleLocalLogin}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            <button type="submit" className="login-btn-local" disabled={loading}>
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default LoginPage;
